import { API } from '../shared/constants/API';
import Request from '../shared/request/Request';
import { ISignIn } from '../models/interfaces/signin.interface';

export const SignIn = async (input: ISignIn) => {
  const result = await Request.post(`${API.AUTH_SERVICE}/signIn`, {
    body: { email: input.email, password: input.password }
  });

  return result;
};

export const SignInBackOffice = async (input: ISignIn) => {
  const result = await Request.post(`${API.AUTH_SERVICE}/signInBackOffice`, {
    body: { email: input.email, password: input.password }
  });

  return result;
};
